import { Pipe, PipeTransform } from '@angular/core';
import { Situation } from '../../models/situation';

@Pipe({
	name: 'filterSituationByName'
})
export class FilterSituationByNamePipe implements PipeTransform {
	transform(situation: Situation[], filter: string): Situation[] {
		if (
			!situation ||
			!filter ||
			situation === null ||
			filter === null ||
			filter === ''
		) {
			return situation;
		}

		return situation.filter((situation: Situation) => {
			if (situation.name) {
				// TODO: add lastName too
				return situation.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
